import styled from 'styled-components';
import { RxShare2 } from 'react-icons/rx';
import pplezSvg from '@src/assets/imgs/pplezIcon.svg';
import Image from 'next/image';
import DetailStatus from '@src/components/Molecules/Card/DetailStatus';
import { devices } from '@src/styles/theme';
import Info from '@src/components/Molecules/Card/Info';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { useCallback, useRef, useState } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/virtual';
import { useDonationShareMutaion } from '@src/hooks/useCommunitys';
import { communintyDateFormat } from '@src/utils/date';
import useHover from '@src/hooks/useHover';
import { ImEnlarge2 } from 'react-icons/im';
import BloodHomeReview from '@src/components/Molecules/Card/BloodHomeReview';
import { useRouter } from 'next/router';
import { convertLinksToHyperlinks } from '@src/utils/community';
import ShareSvg from '@src/assets/imgs/share.svg';
import { modalAtom } from '@src/recoils/atom/modal';
import { useSetRecoilState } from 'recoil';
import { useBodyScrollLock } from '@src/hooks/useBodyScrollLock';

type Props = {
  community: any;
  isMine: boolean;
};

const DetailContent = ({ community, isMine }: Props) => {
  console.log(community);
  const router = useRouter();
  const { mutate: onShare } = useDonationShareMutaion(community?.uuid, true);
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const handleButtonClick = (ImgUrl: string) => {
    window.open(ImgUrl);
  };
  const setModal = useSetRecoilState(modalAtom);
  const { lockScroll } = useBodyScrollLock();
  return (
    <>
      <CardContainer>
        <FlexCenter>
          <BoardWriter>
            <Image
              src={community?.writer?.profileImageUrl}
              width={34}
              height={34}
              loader={() => community.writer.profileImageUrl}
              alt={'프로필이미지'}
              style={{
                borderRadius: '50%',
                marginRight: 14,
              }}
            />
            <span>{community?.writer?.displayName}</span>
          </BoardWriter>
          {router.pathname.includes('board') && (
            <WriteTime>{communintyDateFormat(community?.createdAt)}</WriteTime>
          )}
          {router.pathname.includes('donation') && (
            <WriteTime>
              {communintyDateFormat(community?.lastRenewedAt)}
            </WriteTime>
          )}
        </FlexCenter>
        <div
          style={{
            marginTop: 15,
          }}
        >
          <Info community={community} />
        </div>
        <FlexCenter>
          <Title>{community?.title}</Title>
        </FlexCenter>
        <ContentText
          dangerouslySetInnerHTML={convertLinksToHyperlinks(community?.content)}
        ></ContentText>
        {community?.images && community?.images[0]?.length > 0 && (
          <>
            {/* 이미지가 2개이상 이면 슬라이드를 붙여준다. */}
            {community?.images.length > 1 && (
              <ImageWrap ref={hoverRef}>
                <Swiper
                  modules={[Virtual, Navigation, Scrollbar, Pagination, A11y]}
                  spaceBetween={1}
                  slidesPerView={1}
                  navigation={true}
                  pagination={{ clickable: true }}
                >
                  {community?.images?.map((imgUrl: any, i: number) => (
                    <SwiperSlide key={i} virtualIndex={i}>
                      <ImageWrap ref={hoverRef}>
                        <PpleImage
                          loader={() => imgUrl}
                          src={imgUrl}
                          alt={community?.content}
                          width={700}
                          height={700}
                          // fill={true}
                        />
                        {isHovered && (
                          <InLargeWrap
                            onClick={() => {
                              handleButtonClick(imgUrl);
                            }}
                          >
                            <IsExtendIcon />
                          </InLargeWrap>
                        )}
                      </ImageWrap>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </ImageWrap>
            )}
            {/* 이미지가 1개라면 그냥 보여준다. */}
            {community?.images.length === 1 && (
              <ImageWrap ref={hoverRef}>
                <PpleImage
                  loader={() => community?.images[0]}
                  src={community?.images[0]}
                  alt={community?.content} // for SEO
                  style={{
                    cursor: 'pointer',
                  }}
                  width={700}
                  height={700}
                />
                {isHovered && (
                  <InLargeWrap
                    onClick={() => {
                      handleButtonClick(community?.images[0]);
                    }}
                  >
                    <IsExtendIcon />
                  </InLargeWrap>
                )}
              </ImageWrap>
            )}
          </>
        )}
        {community?.bloodHome && (
          <div
            style={{
              marginTop: 30,
            }}
          >
            <BloodHomeReview
              name={community?.bloodHomeName}
              address={community.bloodHome?.address?.location}
              rating={community.gpa!}
            />
          </div>
        )}
        {
          // 사연과 생활분리
          community?.status && (
            <Flex
              style={{
                justifyContent: 'flex-end',
              }}
            >
              <ShareButton
                onClick={(e) => {
                  e.stopPropagation();
                  const body = {
                    donationUuid: community.uuid,
                  };
                  onShare(body);
                }}
              >
                <ShareIcon />
                <span>공유해서 도움주기</span>
              </ShareButton>
              {(router.pathname.includes('donation') ||
                router.pathname.includes('post')) &&
                !isMine && (
                  <ChatShareButton
                    onClick={() => {
                      lockScroll();
                      setModal({
                        id: 'appDown',
                        visible: true,
                      });
                    }}
                  >
                    채팅으로 도움주기
                  </ChatShareButton>
                )}
            </Flex>
          )
        }
        <Line />
        <Flex>
          <DetailStatus
            isDonation={!!community?.status}
            community={community}
            isMine={isMine}
          />
        </Flex>
      </CardContainer>
    </>
  );
};

const Line = styled.div`
  height: 0px;
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  margin: 15px 0;
`;

const PplezIcon = styled(pplezSvg)`
  margin-right: 8px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  @media ${devices.tablet} {
    /* display: block; */
    > button {
      width: 100%;
      margin-top: 10px;
    }
  }
`;

const CardContainer = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.commonColor.white};
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  padding: 1rem 2rem;
  display: block;
  width: 100%;
  > img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
  @media ${devices.tablet} {
    border: none;
  }
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Writer = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.commonColor.gray005};
  display: flex;
  align-items: center;
`;

const WriteTime = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.commonColor.gray004};
`;

const Title = styled.h4`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.commonColor.black};
  margin: 20px 0 10px 0;
`;

const ContentText = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.commonColor.black};
  line-height: 24px;
  letter-spacing: -0.6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

const StoryInfoWrap = styled.div`
  button:not(:last-child) {
    margin-right: 8px;
  }
`;

const StoryInfoButton = styled.button<{ isExtention: boolean }>`
  background-color: ${({ theme, isExtention }) =>
    isExtention ? theme.commonColor.pink004 : theme.commonColor.gray002};
  padding: 4px 8px;
  color: ${({ theme, isExtention }) =>
    isExtention ? theme.commonColor.white : theme.commonColor.gray005};
  border-radius: 3px;
  font-size: 12px;
`;

const ShareButton = styled.button`
  background-color: ${({ theme }) => theme.commonColor.pink004};
  border-radius: 8px;
  padding: 6px 17px;
  color: ${({ theme }) => theme.commonColor.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  > span {
    margin-left: 6px;
    font-family: 'Regular';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.6px;
  }
  cursor: pointer;
  @media ${devices.tablet} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
    padding: 4px 12px;
    > span {
      font-size: 12px;
    }
  }
`;
const ShareIcon = styled(ShareSvg)``;

const ImageWrap = styled.div`
  position: relative;
  width: 700px;
  height: 700px;
  margin-top: 10px;
  @media ${devices.tablet} {
    width: 100%;
    height: 100%;
    /* margin: 0 auto; */
  }
`;

const InLargeWrap = styled.div`
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 8px;
  border-radius: 5px;
  transition: 0.5s;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const IsExtendIcon = styled(ImEnlarge2)`
  width: 100%;
  height: 100%;
  color: #fff;
`;

const PpleImage = styled(Image)`
  cursor: pointer;
  /* object-fit: contain; */
  width: 700px;
  height: 700px;
  @media ${devices.tablet} {
    width: 100%;
    height: 100%;
  }
`;

const BoardWriter = styled.div`
  color: #979797;
  font-family: 'Regular';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
  @media ${devices.tablet} {
  }
`;

const ChatShareButton = styled.button`
  box-shadow: 2px 1px 14px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.commonColor.white};
  color: ${({ theme }) => theme.commonColor.pink004};
  border: 1px solid ${({ theme }) => theme.commonColor.pink004};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.03em;
  /* width: 200px; */
  margin-left: 20px;
  cursor: pointer;
  @media ${devices.tablet} {
    padding: 8px 12px;
    font-size: 12px;
  }
`;

export default DetailContent;
